exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._27L1Y,.hJjGW{padding:20px 20px 0;width:100%;text-align:right}._3V-1D{resize:none;border:none;padding:10px 20px;min-height:150px;background-color:#f5f5f5;width:100%;border-radius:4px}._3V-1D:focus,.Z9EkR{outline:none}.Z9EkR{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:10px 35px;font-size:14px;line-height:24px;color:#000;font-weight:700;background-color:#ffd903;border:none;cursor:pointer}.hJjGW .Z9EkR{width:auto}.Z9EkR:hover{color:#111;opacity:1;background-color:#ffc107}.XvxhI,.Z9EkR:disabled:hover{background-color:#dcdcdc;color:#4e4d4d}._2QStj{font-size:12px;color:#6b6b6b;margin-bottom:4px;text-align:left;line-height:1.2}@media screen and (max-width:480px){.Z9EkR{border-radius:4px;padding:6px 30px}}._1gtfy,.hJjGW ._1gtfy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.hJjGW ._1gtfy{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", ""]);

// exports
exports.locals = {
	"root": "_27L1Y",
	"rootMobile": "hJjGW",
	"textareaMsg": "_3V-1D",
	"btnSend": "Z9EkR",
	"disabledBtn": "XvxhI",
	"verifyInfoMsg": "_2QStj",
	"infoBlock": "_1gtfy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/DialogForm/DialogForm.css
// module id = 2713
// module chunks = 25 32